import { Box, Text, Link, Flex } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import * as routesNames from '../../../../constants/routes';

interface IncrementMarqueeProps {
  incrementNotification?: any;

}

const IncrementMarquee = ({ incrementNotification }: IncrementMarqueeProps) => {
  const navigate = useNavigate();

  const isApproved = incrementNotification?.approved === true;

const Content = () => (
  <Text
    className="font-poppins text_lg text_semibold"
    px={8}
  >
    🚀 Our new website is now live! Please use and login here :
    <Link ml={1} color="blue.600" textDecoration="underline" isExternal href="https://tek.hrlense.com">
      https://tek.hrlense.com
    </Link>
    {" | "}
    ⚠ The current website will not remain accessible for internal users from next week.
  </Text>
);

  return (
    <Box bg= "green.50"  border="1px solid" borderColor="transparent" py={2} borderRadius="md" overflow="hidden" position="relative">
     <Box
  overflow="hidden"
  position="relative"
  w="100%"
>
  <Flex
    whiteSpace="nowrap"
    width="max-content"
    animation="marquee 20s linear infinite"
  >
    <Content />
    <Content />
  </Flex>

  <style>
    {`
      @keyframes marquee {
        0% {
          transform: translateX(0%);
        }
        100% {
          transform: translateX(-50%);
        }
      }
    `}
  </style>
</Box>
    </Box>
  );
};

export default IncrementMarquee;